import React, { useCallback, useMemo } from 'react';

import PropTypes from 'prop-types';

import {
  normalizeRatingValue,
  serializeRatingValue,
} from '../utils';
import TextFieldField from './TextFieldField';

const RatingField = ({
  data, value, disabled, isDiff, onChange, validate, savedError, onValidationChange,
}) => {
  const inputProps = useMemo(() => {
    const props = { step: 1 };
    if (data.min != null) props.min = data.min;
    if (data.max != null) props.max = data.max;
    return props;
  }, [data.min, data.max]);

  const handleChange = useCallback((nextValue, fieldData, onCancel) => {
    let scaleMax;
    if (data.max != null) {
      scaleMax = data.max;
    } else {
      const existingScaleMax = value && typeof value === 'object'
        ? Number(value.scale_max ?? value.max)
        : NaN;
      const nextNum = Number(nextValue);
      scaleMax = Number.isFinite(existingScaleMax)
        ? Math.max(existingScaleMax, Number.isFinite(nextNum) ? nextNum : existingScaleMax)
        : nextNum;
    }
    onChange(serializeRatingValue({ value: nextValue, scale_max: scaleMax }), fieldData, onCancel);
  }, [data.max, onChange, value]);

  return (
    <TextFieldField
      data={data}
      value={String(normalizeRatingValue(value, data.max).value ?? '')}
      disabled={disabled}
      isDiff={isDiff}
      type="number"
      inputProps={inputProps}
      validate={validate}
      savedError={savedError}
      onValidationChange={onValidationChange}
      onChange={handleChange}
    />
  );
};

RatingField.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
  }).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]),
  disabled: PropTypes.bool,
  isDiff: PropTypes.bool,
  validate: PropTypes.func,
  savedError: PropTypes.string,
  onValidationChange: PropTypes.func,
  onChange: PropTypes.func.isRequired,
};

RatingField.defaultProps = {
  value: '',
  disabled: false,
  isDiff: false,
  validate: null,
  savedError: null,
  onValidationChange: null,
};

export default RatingField;
